// extracted by mini-css-extract-plugin
export var copyableField = "_sl-4";
export var customerBadge = "_sl-0";
export var customerInfoTitle = "_sl-2";
export var details = "_sl-1";
export var dropdownContainer = "_sl-5";
export var dropdownImage = "_sl-6";
export var editAssigneeForm = "_sl-a";
export var editButton = "_sl-3";
export var email = "_sl-7";
export var hidden = "_sl-d";
export var input = "_sl-8";
export var saveButton = "_sl-b";
export var shopifyIcon = "_sl-c";
export var suggestionBadge = "_sl-e";
export var suggestionText = "_sl-f";
export var username = "_sl-9";